module.exports = __webpack_public_path__ + "static/img/cover.ea3b01e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/10/cover.jpg
// module id = gbi1
// module chunks = 27